<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">FX Cost Rate</div>
        <div>
          <bread-crumb :bread-crumbs="['FX Rate Cost']" />
        </div>
      </v-card-title>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="RatesSummary"
        :search="search"
        dense
        item-key="country"
      >
        <template #item="{ item }">
          <tr :class="item.rate_level === 'CW' ? 'bgcolor' : ''">
            <td>{{ item.country }}</td>
            <td>{{ item.partner_name }}</td>
            <td>{{ item.currency_code }}</td>
            <td>{{ item.buy_rate }}</td>
            <td>{{ item.sell_rate }}</td>
            <td>
              {{ item.average_rate }}
              <v-icon
                small
                title="Edit"
                color="primary"
                class="mr-2"
                @click="openAvgRate(item)"
              >
                mdi-content-save-edit-outline
              </v-icon>
            </td>
            <td>{{ item.modified_by }}</td>
            <td>
              <div class="d-flex">
                <v-icon
                  small
                  title="Edit"
                  color="primary"
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-content-save-edit-outline
                </v-icon>
                <v-icon
                  small
                  title="Delete"
                  color="primary"
                  class="mr-2"
                  @click="deleteItem(item)"
                >
                  mdi-trash-can-outline
                </v-icon>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-row class="ms-1 me-1 mt-5">
            <div class="d-flex">
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 text-decoration-none"
                color="primary"
                @click="openDialog"
              >
                <v-icon small class="me-2">mdi-plus</v-icon> Add Country Rate
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize text-decoration-none me-2"
                color="primary"
                @click="openPartnerDialog"
                ><v-icon small class="me-2">mdi-plus</v-icon>Add Partner
                Rate</v-btn
              >
            </div>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card>
          <v-form ref="Addcountryform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>{{ formtitle }} Country Rate</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Country
                  </label>
                  <v-autocomplete
                    class="rounded"
                    dense
                    v-model="country_ratedata.country"
                    outlined
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                    :rules="FieldRequired('Country')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Currency
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    disabled
                    v-model="country_ratedata.currency_code"
                    outlined
                    placeholder="Currency"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Buying Rate
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="country_ratedata.buy_rate"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Buying Rate"
                    item-text="txt"
                    item-value="val"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Buying Rate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Selling Rate
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="country_ratedata.sell_rate"
                    type="number"
                    hide-spin-buttons
                    dense
                    outlined
                    placeholder="Selling Rate"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Selling Rate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize">
                    Rate Difference
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    v-model="country_ratedata.rate_difference"
                    readonly
                    type="number"
                    hide-spin-buttons
                    placeholder="Rate Difference"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="onSubmitFor('country')"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>
                {{ country_ratedata.id ? "Update" : "Add" }}
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeDialog()"
                ><v-icon small>mdi-close-circle-outline</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showPartnerDialog" width="500">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>{{ formtitle }} Payout Partner Rate</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closePartnerDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Country
                  </label>
                  <v-autocomplete
                    class="rounded"
                    v-model="partner_ratedata.country"
                    dense
                    outlined
                    placeholder="Country"
                    @input="getpartnerbyCountry(partner_ratedata.country)"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                    :rules="FieldRequired('Country')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Payout Partner
                  </label>
                  <v-autocomplete
                    class="rounded"
                    v-model="partner_ratedata.partner"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="partnerList"
                    placeholder="Payout Partner"
                    :rules="FieldRequired('Partner')"
                    @input="getPartnerCurrency(partner_ratedata.partner)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Currency
                  </label>
                  <v-autocomplete
                    class="rounded"
                    v-model="partner_ratedata.currency_code"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="partnerCurrency"
                    placeholder="Currency"
                    :rules="FieldRequired('Currency')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Buying Rate
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="partner_ratedata.buy_rate"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Buying Rate"
                    item-text="txt"
                    item-value="val"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Buying Rate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Selling Rate
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="partner_ratedata.sell_rate"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Selling Rate"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Selling Rate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Rate Difference
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Rate Difference"
                    v-model="partner_ratedata.rate_difference"
                    :rules="FieldNumbRequired('Rate Difference')"
                  ></v-text-field>
                </v-col>
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="onSubmitFor('partner')"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>
                {{ partner_ratedata.id ? "Update" : "Add" }}
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closePartnerDialog()"
                ><v-icon small>mdi-close-circle-outline</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showAvgRateDialog" width="500">
        <v-card>
          <v-form ref="Addavgform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>Update Average Cost Rate</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeAvgDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Previous Balance
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="Average_ratedata.previous_balance"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Previous Balance"
                    item-text="txt"
                    item-value="val"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Previous Balance')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Current Balance
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="Average_ratedata.current_balance"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Current Balance"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Current Balance')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Previous Rate
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="Average_ratedata.previous_rate"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Previous Rate"
                    item-text="txt"
                    item-value="val"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired(' Previous Rate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Current Rate
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="Average_ratedata.current_rate"
                    dense
                    outlined
                    type="number"
                    hide-spin-buttons
                    placeholder="Current Rate"
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Current Rate')"
                  ></v-text-field>
                </v-col>
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    justify-content: right;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                >
                  <v-btn
                    depressed
                    color="primary"
                    min-width="170px"
                    class="me-5 text-capitalize"
                    @click="updateAvgRate()"
                  >
                    Update
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    outlined
                    min-width="170px"
                    @click="closeAvgDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteFxCostRate()"
            >
              Delete<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  mixins: [alerts],
  name: "FX Rate Cost",
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      // expanded: [],
      search: "",
      loader: false,
      showDialog: false,
      showPartnerDialog: false,
      deleteDialog: false,
      showAvgRateDialog: false,
      delete_id: null,
      editedIndex: -1,
      valid: true,
      country_options: [],
      country_object: [],
      partnerList: [],
      partnerCurrency: [],
      country_ratedata: {
        country: null,
        buy_rate: 0,
        sell_rate: 0,
        currency_code: null,
        rate_difference: 0,
        rate_level: "CW",
        txn_type: "IND",
      },
      Average_ratedata: {
        buy_rate: 0,
        sell_rate: 0,
        previous_balance: 0,
        current_balance: 0,
        previous_rate: 0,
        current_rate: 0,
      },
      partner_ratedata: {
        country: null,
        partner: null,
        buy_rate: 0,
        sell_rate: 0,
        currency_code: null,
        rate_difference: 0,
        rate_level: "PW",
        txn_type: "IND",
      },
      dessertHeaders: [
        {
          text: "Country",
          sortable: false,
          value: "country",
        },
        { text: "Partner", value: "partner_name" },
        { text: "Currency", value: "currency_code" },
        { text: "1 USD - Currency", value: "buy_rate" },
        { text: "Base currency - payout currency", value: "sell_rate" },
        { text: "Average Rate", value: "average_rate" },
        { text: "Last Updated", value: "modified_by" },
        { text: "Action", value: "action", sortable: false },
      ],
      RatesSummary: [],
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.getBeneCountryList();
    this.getAllFixCostRates();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  watch: {
    "country_ratedata.buy_rate"(val) {
      this.country_ratedata.rate_difference =
        this.country_ratedata.sell_rate - val;
    },
    "country_ratedata.sell_rate"(val) {
      this.country_ratedata.rate_difference = parseFloat(
        (val - this.country_ratedata.buy_rate).toFixed(4),
      );
    },
    "country_ratedata.country"(val) {
      this.country_object.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.country_ratedata.currency_code = ele.currency_code;
        }
      });
    },
    "partner_ratedata.buy_rate"(val) {
      this.partner_ratedata.rate_difference =
        this.partner_ratedata.sell_rate - val;
    },
    "partner_ratedata.sell_rate"(val) {
      this.partner_ratedata.rate_difference = parseFloat(
        (val - this.partner_ratedata.buy_rate).toFixed(4),
      );
    },
  },
  methods: {
    itemRowBackground(items) {
      console.log("tim", items);
      return items.rate_level === "CW" ? "bgcolor" : "";
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    deleteItem(item) {
      this.deleteDialog = true;
      this.delete_id = item.id;
    },
    openAvgRate(item) {
      console.log(item);
      this.showAvgRateDialog = true;
      this.Average_ratedata = item;
    },
    editItem(item) {
      this.editedIndex = 1;
      if (item.rate_level === "CW") {
        this.showDialog = true;
      } else {
        this.showPartnerDialog = true;
      }
      this.getById(item.id);
    },
    async getById(id) {
      this.loader = true;
      try {
        const response = await setupService.getCostRatesById(id);
        if (response.data.status_code === 200) {
          const fxcostData = response.data.data[0];
          if (fxcostData.rate_level === "CW") {
            this.country_ratedata = response.data.data[0];
          } else {
            this.getpartnerbyCountry(response.data.data[0].country);
            this.partner_ratedata = response.data.data[0];
          }
          this.stoploader();
        } else {
          this.stoploader();
        }
      } catch (error) {
        this.stoploader();
        console.error(error);
      }
    },
    async deleteFxCostRate() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteFxCostRate(
          this.delete_id,
        );
        console.log(`up: ${JSON.stringify(responseData)}`);

        if (responseData.data.status_code === 200) {
          this.loader = false;
          this.deleteDialog = false;
          this.getAllFixCostRates();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.loader = false;
          this.deleteDialog = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.deleteDialog = false;
        this.showAlertError("Technical Error: Something went wrong");
        console.error(e);
      }
    },
    async downloadExcelsheet() {
      if (this.RatesSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.RatesSummary,
          "RatesSummary",
        );
      }
    },
    openDialog() {
      this.showDialog = true;
      this.country_ratedata = {};
      this.editedIndex = -1;
      this.country_ratedata.rate_level = "CW";
      this.country_ratedata.txn_type = "IND";
      if (this.$refs.Addcountryform) {
        this.$refs.Addcountryform.reset();
        this.$refs.Addcountryform.resetValidation();
      }
    },
    openPartnerDialog() {
      this.showPartnerDialog = true;
      this.editedIndex = -1;
      this.partner_ratedata = {};
      this.partner_ratedata.buy_rate = 0;
      this.partner_ratedata.sell_rate = 0;
      this.partner_ratedata.rate_difference = 0;
      this.partner_ratedata.rate_level = "PW";
      this.partner_ratedata.txn_type = "IND";
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
        this.$refs.Addcountryform.resetValidation();
      }
    },
    closeDialog() {
      this.loader = false;
      this.showDialog = false;
      this.$refs.Addcountryform.reset();
    },
    closePartnerDialog() {
      this.loader = false;
      this.showPartnerDialog = false;
      this.$refs.Addform.resetValidation();
    },
    closeAvgDialog() {
      this.loader = false;
      this.showAvgRateDialog = false;
      this.$refs.Addavgform.resetValidation();
    },
    async getAllFixCostRates() {
      this.loader = true;
      try {
        const responseData = await setupService.getAllFixCostRates({
          txn_type: "IND",
        });
        console.log(`up: ${JSON.stringify(responseData)}`);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          // this.showAlertSuccess(responseData.data.message);
          this.RatesSummary = [];
          console.log("rate summary", responseData.data.data);
          responseData.data.data.map((ele) => {
            // it's check country id and if null and list partner rates
            if (ele.id === null && ele.partner_wise_list.length > 0) {
              this.RatesSummary.push(...ele.partner_wise_list);
            } else if (ele.id) {
              this.RatesSummary.push(ele);
              if (ele.partner_wise_list.length > 0) {
                this.RatesSummary.push(...ele.partner_wise_list);
              }
            }
          });
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async deleteLedgerById() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteFxCostRate(
          this.delete_id,
        );
        console.log(`up: ${JSON.stringify(responseData)}`);

        if (responseData.data.status_code === 200) {
          this.loader = false;
          this.showBlockDialog = false;
          this.getAllFixCostRates();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.loader = false;
          this.showBlockDialog = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.showBlockDialog = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    onSubmitFor(data_type) {
      if (data_type === "country") {
        const validate = this.$refs.Addcountryform.validate();
        if (validate) {
          if (this.country_ratedata.id) {
            this.update(this.country_ratedata, this.country_ratedata.id);
          } else {
            this.save(this.country_ratedata);
          }
        }
      } else if (data_type === "partner") {
        const validate = this.$refs.Addform.validate();
        if (validate) {
          if (this.partner_ratedata.id) {
            this.update(this.partner_ratedata, this.partner_ratedata.id);
          } else {
            this.save(this.partner_ratedata);
          }
        }
      }
    },
    async save(data) {
      this.loader = true;
      try {
        const responseData = await setupService.addFxCostRate(data);
        console.log(`up: ${JSON.stringify(responseData)}`);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.getAllFixCostRates();
          this.showAlertSuccess(responseData.data.message);
          this.showDialog = false;
          this.showPartnerDialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async update(data, id) {
      this.loader = true;

      try {
        const responseData = await setupService.updateFxCostRate(id, data);
        console.log(`up: ${JSON.stringify(responseData)}`);
        setTimeout(() => {
          this.loader = false;
        }, 300);
        if (responseData.data.status_code === 200) {
          this.getAllFixCostRates();
          this.showAlertSuccess(responseData.data.message);
          this.showDialog = false;
          this.showPartnerDialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async updateAvgRate() {
      const validate = this.$refs.Addavgform.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await setupService.updateFxCostRate(
            this.Average_ratedata.id,
            this.Average_ratedata,
          );
          console.log(`up: ${JSON.stringify(responseData)}`);
          setTimeout(() => {
            this.loader = false;
          }, 300);
          if (responseData.data.status_code === 200) {
            this.getAllFixCostRates();
            this.showAlertSuccess(responseData.data.message);
            this.showAvgRateDialog = false;
          } else {
            this.showAlertError(responseData.data.message);
          }
          console.log("respose data", responseData);
        } catch (e) {
          this.showAlertError("fetch data Something went wrong");
          console.error(e);
        }
      }
    },
    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
          this.country_object = responseData.data.data.map((i) => {
            return i;
          });
        }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getpartnerbyCountry(country_code) {
      this.loader = true;
      try {
        const responseData =
          await partnerService.getAllPayoutPartnersBysettleCry({
            country: country_code,
            currency: "USD",
          });
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          console.log(responseData.data);
          this.partnerList = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("getBeneCountryList", this.partnerList);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getPartnerCurrency(id) {
      try {
        const response = await partnerService.getallAllowpartnerCurrency(id);
        if (response.data.status_code === 200) {
          console.log("Currency", response.data.data);
          this.partnerCurrency = response.data.data.map((i) => {
            return { txt: i.currency_code, val: i.currency_code };
          });
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}
.bgcolor > td {
  background-color: rgb(245, 245, 245) !important;
  font-weight: 500 !important;
}
.required:after {
  content: " *";
  color: red;
}
</style>
